<template>
    <div id="random-recipes">
        <div class="card">
            <div class="list-group list-group-flush">
                <a
                    v-for="recipe in recipes"
                    class="list-group-item list-group-item-action"
                    :href="'/recipes/' + recipe.slug"
                    :title="recipe.name"
                    >{{ recipe.name }}</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RandomRecipes",
    props: ["recipes"],
};
</script>
<style scoped></style>
